import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MenuConfiguration } from 'src/business/models/main-configuration.model';
import { Link } from 'src/core-lib/navigation/models/link.model';
import { MediaModule } from 'src/layout/media/media.module';
import { StorageUtil } from 'src/utils/storage.util';

@Component({
    selector: 'app-footer-menu',
    templateUrl: './footer-menu.component.html',
    styleUrls: ['./footer-menu.component.scss'],standalone: true,
    imports:[CommonModule, TranslateModule, MediaModule, RouterModule],

    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterMenuComponent {
    @Input() @HostBinding('style.--direction') direction: 'column' | 'row' = 'row';
    @Input() menu: Link[] = StorageUtil.get<MenuConfiguration>('menu').footerMenu
}
